import { render, staticRenderFns } from "./VaimoBooxiLifeTimeLabel.vue?vue&type=template&id=10e99b02&scoped=true&"
import script from "./VaimoBooxiLifeTimeLabel.vue?vue&type=script&lang=ts&"
export * from "./VaimoBooxiLifeTimeLabel.vue?vue&type=script&lang=ts&"
import style0 from "./VaimoBooxiLifeTimeLabel.vue?vue&type=style&index=0&id=10e99b02&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e99b02",
  null
  
)

export default component.exports